module.exports = __webpack_public_path__ + "img/index-banner.359d0237.png";